import React from 'react';
import FeaturedBlogCard from './FeaturedBlogCard';
import FeaturedBlogCard2 from './assets/pop up eco nirmit.png';
import BlogCard from './BlogCard';
import { Container } from '@mui/material';
import BlogCardContainer from './BlogCardContainer';
import BlogTags from './BlogTags';

function Blogs() {
  return (
    <Container>    <div className='p-5'>
    <div class="section__header spacing--large md:text-center text-center">
        <h1 class="section__heading hd2">
          News
        </h1>
      </div>
      <FeaturedBlogCard
        image={FeaturedBlogCard2}
        date="May 28, 2025"
        title="Best High-Protein Snacks for Gym & Travel"
        link="news/best-high-protein-snacks-for-gym-travel.html"
      />
      <BlogTags/>
          <BlogCardContainer/>
    </div>
    </Container>

  );
}

export default Blogs;
